import ActiveRecord from './active_record/base'

class ExtRevenueGroup extends ActiveRecord {
	static tableName = 'integrationExtRevenueGroups'
	static defaultJoins = ['omzetGroepen', 'environments']
}

export default ExtRevenueGroup
